import { CampaignName } from 'src/common/enums/campaigns';
import { CampaignConfig, CampaignElementType } from 'src/common/interfaces/campaigns';
import { UserData } from 'src/common/interfaces';
import { InfluencerCampaignModal } from './influencers/components/influencer-campaign-modal/influencer-campaign-modal';
import { InfluencerCampaignBar } from './influencers/components/influencer-campaign-bar';
import { StarWarsTopBar } from './star-wars/star-wars-top-bar';
import { checkMatch } from './helpers';
import { StarWarsModal } from './star-wars/star-wars-modal';
import { StarWarsAccountCard } from './star-wars/star-wars-account-card';
import { FireshipTopBar } from './fireship/fireship-top-bar';
import { FireshipModal } from './fireship/fireship-modal';
type CampaignConfigPerElement = { [key in CampaignElementType]?: CampaignConfig };
type CampaignConfigPerName = { [key in CampaignName]: CampaignConfigPerElement };
const standardTopBarExclusionPaths: string[] = ['/onboarding/*', '/pricing', '/welcome', '/payment/pending', '/feedback/subscription', '/room/*', '/echo', '/path/outline/*', '/recapme/*', '/login/*', '/certification/*'];
const standardInfluencerTopBarInclusions: string[] = ['/dashboard/*'];
const standardInfluencerEmbeddedBarInclusions: string[] = ['/certification/junior-penetration-tester', '/certification/junior-penetration-tester/details', '/onboarding/*', '/welcome', '/login/*', '/signup/*'];
const standardInfluencerModalInclusions: string[] = ['/certification/junior-penetration-tester/details*', '/room/*'];
const starWarsCampaignConfig: CampaignConfigPerElement = {
  [CampaignElementType.TOP_BAR]: {
    renderComponent: () => <StarWarsTopBar />,
    pathsToExclude: standardTopBarExclusionPaths,
    shouldShow(path, user) {
      const isPremium = !!user?.user?.isPremium;
      const onManageSub = checkMatch(['/manage-account/subscription'], path).doesMatch;
      const onWhySub = checkMatch(['/why-subscribe'], path).doesMatch;
      if (onManageSub) {
        return !isPremium;
      }
      if (onWhySub) {
        return isPremium;
      }
      return true;
    }
  },
  [CampaignElementType.EMBEDDED_BAR]: {
    renderComponent: () => <StarWarsTopBar thin />,
    pathsToInclude: ['/why-subscribe'],
    shouldShow(_path: string, user?: UserData) {
      return !user?.user?.isPremium;
    }
  },
  [CampaignElementType.MODAL]: {
    renderComponent: () => <StarWarsModal />,
    pathsToInclude: ['/dashboard']
  },
  [CampaignElementType.ACCOUNT_CARD]: {
    renderComponent: () => <StarWarsAccountCard />
  }
};
const fireshipCampaignConfig: CampaignConfigPerElement = {
  [CampaignElementType.TOP_BAR]: {
    renderComponent: () => <FireshipTopBar />,
    pathsToInclude: ['/*'],
    pathsToExclude: standardTopBarExclusionPaths,
    shouldShow(path, user) {
      const isPremium = user?.user?.isPremium;
      const isOnManageSub = checkMatch(['/manage-account/subscription'], path).doesMatch;
      return isPremium ? !isOnManageSub : true;
    }
  },
  [CampaignElementType.MODAL]: {
    renderComponent: () => <FireshipModal />,
    pathsToInclude: ['/', '/room/*']
  }
};
const madhatCampaignConfig: CampaignConfigPerElement = {
  [CampaignElementType.TOP_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.MADHAT_2025} />,
    pathsToInclude: standardInfluencerTopBarInclusions
  },
  [CampaignElementType.EMBEDDED_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.MADHAT_2025} />,
    pathsToInclude: standardInfluencerEmbeddedBarInclusions
  },
  [CampaignElementType.MODAL]: {
    renderComponent: () => <InfluencerCampaignModal />,
    pathsToInclude: standardInfluencerModalInclusions,
    pathsToExclude: ['/']
  }
};
const theBeardedITDadCampaignConfig: CampaignConfigPerElement = {
  [CampaignElementType.TOP_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.THE_BEARDED_IT_DAD_2025} />,
    pathsToInclude: standardInfluencerTopBarInclusions
  },
  [CampaignElementType.EMBEDDED_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.THE_BEARDED_IT_DAD_2025} />,
    pathsToInclude: standardInfluencerEmbeddedBarInclusions
  },
  [CampaignElementType.MODAL]: {
    renderComponent: () => <InfluencerCampaignModal />,
    pathsToInclude: standardInfluencerModalInclusions,
    pathsToExclude: ['/']
  }
};
const tylerRamsbeyCampaignConfig: CampaignConfigPerElement = {
  [CampaignElementType.TOP_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.TYLER_RAMSBEY_2025} />,
    pathsToInclude: standardInfluencerTopBarInclusions
  },
  [CampaignElementType.EMBEDDED_BAR]: {
    renderComponent: () => <InfluencerCampaignBar influencerCampaign={CampaignName.TYLER_RAMSBEY_2025} />,
    pathsToInclude: standardInfluencerEmbeddedBarInclusions
  },
  [CampaignElementType.MODAL]: {
    renderComponent: () => <InfluencerCampaignModal />,
    pathsToInclude: standardInfluencerModalInclusions,
    pathsToExclude: ['/']
  }
};
export const CampaignConfigs: CampaignConfigPerName = {
  [CampaignName.FLASH_SALE_STAR_WARS]: starWarsCampaignConfig,
  [CampaignName.FIRESHIP_2025]: fireshipCampaignConfig,
  [CampaignName.MADHAT_2025]: madhatCampaignConfig,
  [CampaignName.THE_BEARDED_IT_DAD_2025]: theBeardedITDadCampaignConfig,
  [CampaignName.TYLER_RAMSBEY_2025]: tylerRamsbeyCampaignConfig
};